export default __webpack_public_path__ + "static/media/Maithili_book2_m.b2d139fe.wav";